<template>
  <roe-error-message :field="design.employer_match_contribution_type">
    <v-select
      name="employer_match_contribution_type"
      v-model.number="design.$model.employer_match_contribution_type"
      :options="[
        {
          code: 1,
          label:
            'Compensation Based'
        },
        {
          code: 2,
          label:
            'Contribution Based'
        }
      ]"
      :reduce="label => label.code"
      @input="resetBased"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchContributionTypeSelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    resetBased() {
      let attr;
      if (this.design.$model.employer_match_contribution_type === 1) {
        attr = "contribution_amount";
        this.design.$model.employer_match_dollar_maximum = null;
        this.design.$model.match_dollar_limit_amount = null;
      } else {
        attr = "deferral_rate";
      }
      this.design.$model.tiers.forEach(tier => (tier[attr] = null));
    }
  }
};
</script>
